export default "__VITE_ASSET__Bpp3ZubC__"